/*       */

import greenlet from 'greenlet';

let validateEval;

export function loadValidateEval() {
    if (!validateEval) {
        validateEval = greenlet((value, fullJs) => {
            try {
                const jsFunction = eval(value); // eslint-disable-line no-eval
                if (typeof jsFunction !== 'function' && !fullJs) {
                    return { isValid: false, errorMessage: 'You must write a valid javascript function.' };
                }
                return { isValid: true, errorMessage: null };
            } catch (e) {
                return { isValid: false, errorMessage: e && e.message };
            }
        });
    }
    return validateEval;
}

let workerEval;

const loadWorkerEval = () => {
    if (!workerEval) {
        workerEval = greenlet(`
            (fnDefinition, ...args) => {
                return eval(fnDefinition)(...args);
            }
        `);
    }
    return workerEval;
}

const worker = async (fnDefinition, ...args) => {
    try {
        const result = await loadWorkerEval()(fnDefinition, ...args);
        return result;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('An error occured executing:\n', fnDefinition, '\n\nusing the arguments', args, '\nERROR:', e);
        throw Error(e);
    }
};

export default worker;
